module.exports = __webpack_public_path__ + "img/main-new_m.40eaf731.jpg";